import { IPrj } from "../prj/IPrj";
import { ILbl } from "./ILbl";
import { IPreflightResult } from "./IPreflightResult";

export class lbl_api {

    public static get_zlecenia:string = "/api/label/get_zlecenia"
    public static get_labels:string = "/api/label/get_labels"
    public static get_labels_short:string = "/api/label/get_labels_short"
    public static find_by_id:string = "/api/label/find_by_id"
    public static set_status:string = "/api/label/set_status"
    public static update:string = "/api/label/update"


    public static start_flow_preflight:string = "/api/label/start_flow_preflight"
    public static end_flow_preflight:string = "/api/label/end_flow_preflight"

    public static start_flow_sekwencja:string = "/api/label/start_flow_sekwencja"
    public static end_flow_sekwencja:string = "/api/label/end_flow_sekwencja"

    public static start_flow_akceptacja:string = "/api/label/start_flow_akceptacja"
    public static end_flow_akceptacja:string = "/api/label/end_flow_akceptacja"

    
    public static assign_tree:string = "/api/label/assign_tree"
    public static assign_prj:string = "/api/label/assign_prj"
    public static duplicate:string = "/api/label/duplicate"

    public static get_call_results:string = "/api/label/get_call_results"
    public static connect_lbls:string = "/api/label/connect_lbls"
    public static disconnect_lbls:string = "/api/label/disconnect_lbls"

}

export interface ILblSvc {

    get_labels(prj_id: any): Promise<ILbl[] | undefined> 
    get_labels_short(searcher:any):Promise<ILbl[] > 
    find_by_id(_id: any): Promise<ILbl | undefined> 
    set_status(lbl:ILbl): Promise<ILbl | undefined> 
    update(lbl:ILbl): Promise<ILbl | undefined> 
    duplicate(_id: any): Promise<ILbl | undefined> 

    assign_tree(lbl_id:any, src_tree_id:any): Promise<ILbl | undefined> 
    assign_prj(lbl:any, prj:IPrj): Promise<ILbl | undefined> 

    start_flow_preflight(lbl:ILbl): Promise<ILbl | undefined> 
    end_flow_preflight(lbl:ILbl, r:IPreflightResult, status:string):Promise<ILbl | undefined> ;

    start_flow_sekwencja(lbl:ILbl): Promise<ILbl | undefined> 
    end_flow_sekwencja(lbl:ILbl, r:IPreflightResult, status:string):Promise<ILbl | undefined> ;


    start_flow_akceptacja(lbl:ILbl): Promise<ILbl | undefined> 
    end_flow_akceptacja(lbl:ILbl, r:IPreflightResult, status:string):Promise<ILbl | undefined> ;

    get_call_results(lbl:ILbl): Promise<ILbl | undefined> ;

}